export default __webpack_public_path__ + "static/media/Muster-Antrag_auf_Soziale_Teilhabe.9be1cb24.pdf";